import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyHomeComponent } from './survey-home.component';
import { FormsModule } from '@angular/forms';
import { RatingModule } from 'ngx-bootstrap/rating';
import { AvatarPillComponent, IconPillComponent, ImageUrlPipe, ImageForRolePipe, UserAvatarPipe } from '@frontend/shared';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LoaderGlobeAnimationDetailComponent } from '../../loaders/loader-globe-animation-detail/loader-globe-animation-detail.component';
import { AlertModule } from 'ngx-bootstrap/alert';



@NgModule({
  declarations: [
    SurveyHomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RatingModule,
    AvatarPillComponent,
    IconPillComponent,
    RouterModule,
    TranslocoModule,
    LoaderGlobeAnimationDetailComponent,
    AlertModule,
    ImageUrlPipe,
    ImageForRolePipe,
    UserAvatarPipe,
  ],
  exports : [
    SurveyHomeComponent
  ]
})
export class SurveyHomeModule { }
